import React from 'react'
import { useTranslation } from 'react-i18next'
import { Info, Swords } from 'lucide-react'
import TeamAvatar from '../../../team/components/TeamAvatar'
import { CARD_CLASS, PumpkinIcon, SectionTitle } from './shared'

// Цвет номера места для первой тройки
const placeClass = (place) => {
  if (place === 1) return 'bg-gradient-to-br from-yellow-300 to-orange-500 text-dark-primary'
  if (place === 2) return 'bg-slate-300 text-dark-primary'
  if (place === 3) return 'bg-amber-700 text-white'
  return 'bg-white/10 text-text-secondary'
}

const TeamRow = ({ team, place, mine, onOpen }) => {
  const { t } = useTranslation()
  return (
    <button
      type="button"
      onClick={() => onOpen(team.id)}
      className={`flex w-full items-center gap-3 rounded-xl border px-3 py-2.5 text-left transition-all active:scale-[0.98] ${
        mine
          ? 'border-orange-400/45 bg-orange-500/10 shadow-[0_0_18px_rgba(255,120,20,0.12)]'
          : 'border-white/5 bg-black/20 hover:border-white/15'
      }`}
    >
      <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-xs font-black tabular-nums ${placeClass(place)}`}>
        {place ?? '—'}
      </span>
      <TeamAvatar team={team} size={34} />
      <span className="min-w-0 flex-1">
        <span className="block truncate text-sm font-bold text-white">{team.name}</span>
        {team.contributors != null && (
          <span className="block text-[11px] text-text-secondary">
            {t('halloweenEvent.top.members', { count: team.contributors })}
          </span>
        )}
      </span>
      <span className="flex shrink-0 items-center gap-1 text-sm font-black tabular-nums text-orange-100">
        <PumpkinIcon size={16} />
        {team.pumpkins}
      </span>
    </button>
  )
}

/**
 * Топ банд по тыквам. Своя банда, если её нет в топе, — отдельной строкой под списком.
 * Пояснение обязательно: места не дают призов, победителей определяет розыгрыш.
 */
const TopTeamsCard = ({ top = [], myTeam = null, onOpen }) => {
  const { t } = useTranslation()
  const mineInTop = top.some((team) => team.is_mine)

  return (
    <section className={`${CARD_CLASS} p-5`}>
      <SectionTitle icon={<Swords size={18} className="text-violet-300" />}>
        {t('halloweenEvent.top.title')}
      </SectionTitle>

      {top.length === 0 ? (
        <p className="mt-4 text-sm text-text-secondary">{t('halloweenEvent.top.empty')}</p>
      ) : (
        <div className="mt-4 space-y-1.5">
          {top.map((team) => (
            <TeamRow key={team.id} team={team} place={team.place} mine={team.is_mine} onOpen={onOpen} />
          ))}
        </div>
      )}

      {myTeam && !mineInTop && (
        <div className="mt-3 border-t border-white/5 pt-3">
          <p className="mb-1.5 text-[11px] font-bold uppercase tracking-wide text-orange-300">
            {t('halloweenEvent.top.yourTeam')}
          </p>
          <TeamRow team={myTeam} place={myTeam.place} mine onOpen={onOpen} />
        </div>
      )}

      <p className="mt-3 flex items-start gap-1.5 text-xs leading-relaxed text-text-secondary">
        <Info size={13} className="mt-0.5 shrink-0" />
        {t('halloweenEvent.top.disclaimer')}
      </p>
    </section>
  )
}

export default TopTeamsCard
